export enum EPlatform {
  /**
   * 桌面端
   */
  WEB = 1,
  /**
   * 移动端
   */
  WAP = 4,

  /**
   * 移动端 ios
   */
  IOS = 5,

  /**
   * 移动端 android
   */
  ANDROID = 6,
}
